module.exports = __webpack_public_path__ + "static/assets/5c48a6aa846c2e5a5a738530fc88ba20.png";